import {Box} from '@mui/material';
import React, {useState} from 'react';

import CustomButton from '../../../components/CustomButton/CustomButton';
import CustomSelectField from '../../../components/CustomFormFields/CustomSelectField/CustomSelectField';
import CustomTextField from '../../../components/CustomFormFields/CustomTextField/CustomTextField';
import {redisOperation} from '../../../service/admin';
import {handleError} from '../../../utils/errors';

const RedisOperation = ({setSnackBarAlert, setIsLoading}) => {
  const [formData, setFormData] = useState({
    operation: {
      type: 'select',
      label: 'Operation Type',
      value: 'GET',
      options: [
        {code: 'GET', label: 'Get'},
        {code: 'SET', label: 'Set'},
        {code: 'DELETE', label: 'Delete'},
      ],
      error: false,
      hide: false,
      helperText: '',
    },
    key: {
      type: 'text',
      label: 'Key',
      value: '',
      error: false,
      hide: false,
      helperText: '',
      multiline: true,
      minWidth: '58%',
    },
    ttl: {
      type: 'number',
      label: 'TTL',
      value: '',
      disabled: true,
      error: false,
      hide: true,
      helperText: '',
    },
    value: {
      type: 'text',
      label: 'Value',
      value: '',
      disabled: true,
      error: false,
      hide: true,
      helperText: '',
      multiline: true,
      minWidth: '95%',
    },
  });

  const handleFormChange = (e) => {
    if (e.target.id === 'operation') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        value: {
          ...prevFormData.value,
          hide: e.target.value === 'SET' ? false : true,
          disabled: e.target.value === 'SET' ? false : true,
          error: false,
          helperText: '',
        },
        ttl: {
          ...prevFormData.ttl,
          hide: e.target.value === 'SET' ? false : true,
          disabled: e.target.value === 'SET' ? false : true,
          error: false,
          helperText: '',
        },
      }));
    } else if (e.target.id === 'key') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        value: {
          ...prevFormData.value,
          hide: formData.operation.value === 'SET' ? false : true,
          error: false,
          helperText: '',
        },
        ttl: {
          ...prevFormData.ttl,
          hide: formData.operation.value === 'SET' ? false : true,
          error: false,
          helperText: '',
        },
      }));
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.id]: {
        ...prevFormData[e.target.id],
        value: e.target.value,
        error: false,
        helperText: '',
      },
    }));
  };

  const validateForm = () => {
    if (!formData.key.value) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        key: {
          ...prevFormData.key,
          error: true,
          helperText: 'required',
        },
      }));
      return false;
    }
    if (formData.operation.value === 'SET' && !formData.value.value) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        value: {
          ...prevFormData.value,
          error: true,
          helperText: 'required',
        },
      }));
      return false;
    }
    return true;
  };

  const handleButtonClick = async (e) => {
    try {
      const isValid = validateForm();
      if (isValid) {
        setIsLoading(true);
        const data = {
          type: 'KEYS',
          operation: formData.operation.value,
          data: [
            {
              key: formData.key.value,
            },
          ],
        };
        if (formData.operation.value === 'SET') {
          data.data[0]['value'] = formData.value.value;
          if (formData.ttl.value) {
            data.data[0]['ttl'] = Number(formData.ttl.value);
          }
        }
        const response = await redisOperation(data);
        if (data.operation === 'GET') {
          if (Array.isArray(response?.data) && response.length === 0) {
            setSnackBarAlert((prevState) => ({
              ...prevState,
              isOpen: true,
              message: 'NOT FOUND',
              severity: 'error',
            }));
          } else {
            setFormData((prevFormData) => ({
              ...prevFormData,
              operation: {
                ...prevFormData.operation,
                value: 'GET',
              },
              key: {
                ...prevFormData.key,
                value: data.data[0]?.key,
                error: false,
                helperText: '',
              },
              ttl: {
                ...prevFormData.ttl,
                hide: false,
                value: response?.data[0]?.ttl,
              },
              value: {
                ...prevFormData.value,
                value: response?.data[0]?.value,
                hide: false,
                error: false,
                helperText: '',
              },
            }));
          }
        } else {
          setSnackBarAlert((prevState) => ({
            ...prevState,
            isOpen: true,
            message: data.operation === 'SET' ? 'saved' : 'deleted',
            severity: 'success',
          }));
        }
      }
    } catch (error) {
      setSnackBarAlert((prevState) => ({
        ...prevState,
        isOpen: true,
        message: handleError(error),
        severity: 'error',
      }));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Box sx={{p: 1, display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
        {formData &&
          Object.keys(formData)?.map((key, index) => {
            if (!formData[key].hide && (formData[key].type === 'text' || formData[key].type === 'number')) {
              return (
                <CustomTextField
                  key={key}
                  type={formData[key].type}
                  label={formData[key].label}
                  id={key}
                  disabled={formData[key].disabled}
                  value={formData[key]?.value}
                  onChange={handleFormChange}
                  error={formData[key]?.error}
                  helperText={formData[key].helperText || ''}
                  multiline={formData[key]?.multiline || false}
                  minWidth={formData[key]?.minWidth}
                />
              );
            }
            if (!formData[key].hide && formData[key].type === 'select') {
              return (
                <CustomSelectField
                  key={key}
                  id={key}
                  label={formData[key].label}
                  disabled={formData[key].disabled}
                  options={formData[key].options}
                  value={formData[key]?.value}
                  onChange={handleFormChange}
                  error={formData[key]?.error}
                  helperText={formData[key].helperText || ''}
                />
              );
            }
            return null;
          })}
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'column', padding: '2rem'}}>
        <CustomButton
          text={formData.operation.options.find((option) => option.code === formData.operation.value).label}
          onClick={handleButtonClick}
        />
      </Box>
    </>
  );
};

export default RedisOperation;
